import React, { ChangeEvent, ReactNode, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import Header from "./Header";
import { TermsProps } from "user/pages/account/TermsAndConditions";
import { useGetCommonCustomer } from "common/hooks/common/useGetCommonCustomer";
import { useGetCommonSender } from "common/hooks/common/useGetCommonSender";
import { useGetWordCategory } from "common/hooks/console/management/word/useGetWordCategory";
import { useGetCommonWords } from "common/hooks/common/useGetCommonWords";
import InputField from "./InputField";
import { ReactComponent as LeftArrow } from "../../assets/icons/leftArrow.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";
import { ReactComponent as Empty } from "../../../common/assets/icons/empty.svg";
import { ReactComponent as Close } from "../../assets/icons/close_black.svg";

type OverlayProps = {
    onClickClose: () => void;
    onClickTarget: ({ name, idx }: { name: string; idx: number }) => void;
    customerIdx?: number | string;
    category?: number;
};
type TermsOverlayProps = {
    detail: TermsProps;
    onClickAgree: () => void;
    onClickClose: () => void;
};
type ComplateOverlayProps = {
    headerTitle: string;
    title: string;
    content: ReactNode;
    extraContent?: ReactNode;
};
type SystemPopupProps = {
    onClickClose: () => void;
    message?: string | ReactNode;
    isConfirm?: boolean;
};

type Props = {
    overlay: { open: boolean; content: ReactNode };
};

const Overlay = React.memo(({ overlay }: Props) => {
    const dialog = useRef<HTMLDialogElement | null>(null);
    const open = overlay.open;

    useEffect(() => {
        if (overlay.open) {
            // dialog.current?.showModal();
            document.body.style.overflow = "hidden";
        } else {
            // dialog.current?.close();
            document.body.style.overflow = "auto";
        }
    }, [overlay]);

    if (open) {
        return (
            <div className="fixed inset-0 flex justify-center tablet:max-w-[100dvw] z-[11]">
                <div className="max-h-[100dvh] w-[100dvw] max-w-[768px] border-x tablet:border-0 overflow-auto">{overlay.content}</div>
            </div>
        );
    }
    return null;

    return (
        <dialog
            ref={dialog}
            // className="max-h-[100dvh] w-[100dvw] max-w-[768px] mx-auto tablet:max-w-[100dvw] tablet:mx-0 backdrop:bg-transparent"
            className="max-h-[100dvh] w-[100dvw] tablet:max-w-[100dvw] z-[11] tablet:mx-0 backdrop:bg-transparent"
        >
            {/* <div className="w-full border-x tablet:border-0">{overlay.content}</div> */}
            <div className="max-h-[100dvh] w-[100dvw] max-w-[768px] mx-auto border-x tablet:border-0 overflow-auto">{overlay.content}</div>
        </dialog>
    );
});
export default Overlay;

// 회사 검색
export const CompanySearchOverlay = ({ onClickClose, onClickTarget, category }: OverlayProps) => {
    const [searchtxt, setSearchtxt] = useState<string>("");
    const { data: customerData } = useGetCommonCustomer(category!, searchtxt);

    return (
        <div className="wrapper bg-white min-h-[100dvh] flex flex-col">
            <div className="py-[8px] flex gap-[10px] sticky top-0 bg-white">
                <button type="button" onClick={onClickClose}>
                    <LeftArrow />
                </button>
                <div className="flex-1 flex bg-[#F3F3F8] rounded-[8px] px-[12px] py-[8px]">
                    <input
                        type="text"
                        value={searchtxt}
                        onChange={e => setSearchtxt(e.target.value)}
                        placeholder="회사와 부서를 검색하세요"
                        className="w-full bg-transparent placeholder:text-[#999999] focus:outline-none"
                    />
                    <SearchIcon />
                </div>
            </div>

            {category === 1 && !searchtxt && (
                <div className="flex flex-col gap-[40px] items-center justify-center flex-1">
                    <Empty />
                    <p className="font-[500] text-[20px] leading-[30px]">회사와 부서를 검색하세요</p>
                </div>
            )}
            {customerData && customerData?.data?.length > 0 && (
                <ul className="py-[20px] flex flex-col gap-[16px]">
                    {customerData?.data.map(item => {
                        return (
                            <li key={item.customer_idx} className="flex justify-between items-center">
                                <p className="cursor-default font-[500]">{item.customer_name}</p>
                                <button
                                    type="button"
                                    className="text-[#484964] text-[14px] leading-[20px] py-[6px] px-[8px] border border-[#dddddd] rounded-[8px]"
                                    onClick={() => onClickTarget({ name: item.customer_name, idx: item.customer_idx })}
                                >
                                    선택하기
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
            {customerData && customerData?.data?.length === 0 && (
                <div className="flex flex-col gap-[40px] items-center justify-center flex-1">
                    <Empty />
                    <p className="font-[500] text-[20px] leading-[30px]">검색 결과가 없습니다</p>
                </div>
            )}
        </div>
    );
};

// 경조사어 검색
export const KeywordSearchOverlay = ({ onClickClose, onClickTarget }: OverlayProps) => {
    const [categoryIdx, setCategoryIdx] = useState<number | null>(null);
    const [searchtxt, setSearchtxt] = useState<string>("");
    const { data: categoryData } = useGetWordCategory();
    const { data: wordData } = useGetCommonWords(searchtxt, categoryIdx!);
    // console.log("categoryData", categoryData);
    // console.log("wordData", wordData?.data);

    const onClickCategory = (idx: number | null) => {
        setCategoryIdx(idx);
    };

    return (
        <div className="max-h-[100dvh] min-h-[100dvh] bg-white flex flex-col">
            <div className="sticky top-0 bg-white border-b bordefr-[#dddddd]">
                <div className="wrapper flex gap-[10px] py-[8px]">
                    <button type="button" onClick={onClickClose}>
                        <LeftArrow />
                    </button>
                    <div className="flex-1 flex bg-[#F3F3F8] rounded-[8px] px-[12px] py-[8px]">
                        <InputField
                            id="searchtxt"
                            name="searchtxt"
                            value={searchtxt}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchtxt(e.target.value)}
                            placeholder="경조사어를 검색해보세요"
                            onClickClearButton={() => setSearchtxt("")}
                            className="bg-transparent !border-none p-0"
                            wrapperClassName="!border-none [&:has(input:focus)]:!border-none"
                            textMaxLength={30}
                        />
                        <SearchIcon />
                    </div>
                </div>
                <ul className="wrapper flex gap-[16px] overflow-x-auto">
                    <li
                        className={`text-nowrap p-[8px] text-[#A3AED0] text-[18px] leading-[28px] font-[400] cursor-pointer ${categoryIdx === null ? "text-black font-bold border-b-[3px] border-black" : "text-[#A3AED0]"}`}
                        onClick={() => onClickCategory(null)}
                    >
                        전체
                    </li>
                    {categoryData?.map(item => {
                        return (
                            <li
                                key={item.event_category_idx}
                                className={`text-nowrap p-[8px] text-[18px] leading-[28px] font-[400] cursor-pointer ${categoryIdx === item.event_category_idx ? "text-black font-bold border-b-[3px] border-black" : "text-[#A3AED0]"}`}
                                onClick={() => onClickCategory(item.event_category_idx)}
                            >
                                {item.event_name}
                            </li>
                        );
                    })}
                </ul>
            </div>

            <ul className="wrapper py-[20px] flex flex-col gap-[16px] overflow-auto flex-1">
                {wordData?.data.map(item => {
                    return (
                        <li key={item.word_idx} className="flex justify-between items-center">
                            <div>
                                <span className="text-[14px] leading-[20px] text-[#999999] font-[500]">{item.category.event_name}</span>
                                <p className="cursor-default font-[500] mt-[4px] break-keep">
                                    {item.wreath_word}({item.search_word})
                                </p>
                            </div>
                            <button
                                type="button"
                                className="shrink-0 text-[#484964] text-[14px] leading-[20px] py-[6px] px-[8px] border border-[#dddddd] rounded-[8px]"
                                onClick={() => onClickTarget({ name: item.wreath_word, idx: item.word_idx })}
                            >
                                선택하기
                            </button>
                        </li>
                    );
                })}
            </ul>

            <div className="wrapper shadow-[0px_0px_12px_2px_#7090B033] rounded-[24px_24px_0_0] py-[12px]">
                <button
                    type="button"
                    className="border border-[#dddddd] rounded-[12px] py-[12px] text-center w-full text-[#484964] leading-[28px] text-[18px] font-[500]"
                    onClick={onClickClose}
                >
                    직접 입력할래요
                </button>
            </div>
        </div>
    );
};

// 명의 검색
export const NameSearchOverlay = ({ onClickClose, onClickTarget, customerIdx }: OverlayProps) => {
    const [searchtxt, setSearchtxt] = useState("");
    const { data: senderData } = useGetCommonSender(customerIdx ? customerIdx.toString() : "0", searchtxt);

    // console.log("명의 검색", senderData);

    return (
        <div className="max-h-[100dvh] min-h-[100dvh] bg-white flex flex-col">
            <div className="wrapper sticky top-0 bg-white flex gap-[10px] py-[8px] ">
                <button type="button" onClick={onClickClose}>
                    <LeftArrow />
                </button>
                <div className="flex-1 flex bg-[#F3F3F8] rounded-[8px] px-[12px] py-[8px]">
                    <InputField
                        id="searchtxt"
                        name="searchtxt"
                        value={searchtxt}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchtxt(e.target.value)}
                        placeholder="명의를 검색해보세요"
                        onClickClearButton={() => setSearchtxt("")}
                        className="bg-transparent !border-none p-0"
                        wrapperClassName="!border-none [&:has(input:focus)]:!border-none"
                        textMaxLength={100}
                    />
                    <SearchIcon />
                </div>
            </div>

            <ul className="wrapper py-[20px] flex flex-col gap-[16px] overflow-auto flex-1">
                {senderData?.data.map(data => {
                    return (
                        <li key={data.sender_idx} className="flex justify-between items-center">
                            <p className="cursor-default font-[500]">{data.default_sender}</p>

                            <button
                                type="button"
                                className="text-[#484964] text-[14px] leading-[20px] py-[6px] px-[8px] border border-[#dddddd] rounded-[8px]"
                                onClick={() => onClickTarget({ name: data.default_sender, idx: data.sender_idx })}
                            >
                                선택하기
                            </button>
                        </li>
                    );
                })}
            </ul>

            <div className="wrapper shadow-[0px_0px_12px_2px_#7090B033] rounded-[24px_24px_0_0] py-[12px]">
                <p className="text-[#484964] text-[14px] leading-[20px] font-[400] mb-[10px] text-center">
                    노조를 가입으로 선택하실 경우, <br />
                    선택하신 명의는 노조 가입 버전으로 변경됩니다.
                </p>
                <button
                    type="button"
                    className="border border-[#dddddd] rounded-[12px] py-[12px] text-center w-full text-[#484964] leading-[28px] text-[18px] font-[500]"
                    onClick={onClickClose}
                >
                    직접 입력할래요
                </button>
            </div>
        </div>
    );
};

export const TermsDetailOverlay = ({ onClickClose, detail, onClickAgree }: TermsOverlayProps) => {
    const { label, content } = detail;
    const title = label.slice(4, label.length);

    return (
        <div className="h-[100dvh] bg-white flex flex-col">
            <Header title="이용약관" onClickClose={onClickClose} />
            <div className="wrapper py-[16px] flex-1 flex flex-col overflow-auto">
                <p className="font-bold text-[20px] leading-[30px] mb-[12px]">{title}</p>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
            <div className="wrapper py-[16px]">
                <button
                    type="button"
                    onClick={onClickAgree}
                    className="bg-[#273219] w-full rounded-[12px] text-white text-[18px] leading-[28px] py-[12px] font-bold"
                >
                    동의하기
                </button>
            </div>
        </div>
    );
};

export const ComplateOverlay = ({ headerTitle, title, content, extraContent }: ComplateOverlayProps) => {
    return (
        <div className="flex flex-col absolute inset-0 bg-gradient-to-b from-[#fff] to-[#F4FCEA] max-w-[768px] mx-auto">
            <Header title={headerTitle} />
            <div className="wrapper flex-1 flex flex-col pt-[160px] pb-[24px] mobile450:pt-[60px]">
                <div className="flex-1 flex flex-col items-center gap-[40px]">
                    <Logo className="w-[245px] h-[60px] [&_a]:w-full [&_a]:h-full [&_a]:bg-contain mobile450:w-[147px] mobile450:h-[36px] " />
                    <div className="text-center">
                        <p className="text-[#273219] font-bold text-[24px] leading-[36px] mb-[8px]">{title}</p>
                        <div className="break-keep text-[18px] leading-[28px] whitespace-pre-line">{content}</div>
                    </div>
                    {extraContent ?? extraContent}
                </div>
                <Link
                    to="/"
                    className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] text-center"
                >
                    로그인하기
                </Link>
            </div>
        </div>
    );
};
export const cancelMessage = (isUpdate: boolean = false) => (
    <div className="px-[20px]">
        <p className="text-center">{isUpdate ? "주문 수정을 취소하시겠습니까?" : "주문을 취소하시겠습니까?"}</p>
        <p className="text-center font-[500] text-[18px] leading-[28px] text-[#484964] mt-[8px]">입력한 내용은 저장되지 않습니다.</p>
    </div>
);
export const SystemPopup = ({ onClickClose, message, isConfirm = false }: SystemPopupProps) => {
    return (
        <div className="flex justify-center items-center min-h-[100dvh] bg-black/40">
            <div className="max-w-[70%] shadow-[0px_2px_12px_2px_#7090B033] rounded-[12px] overflow-hidden bg-white">
                <div className="px-[16px] pb-[16px]">
                    <div className="h-[40px] flex items-center justify-end">
                        <button type="button" onClick={onClickClose} title="닫기">
                            <Close width={12} height={12} className="[&_path]:stroke-[#A3AED0]" />
                        </button>
                    </div>

                    {message && <div className="font-bold text-[20px] leading-[30px] mb-[8px] break-keep">{message}</div>}
                </div>
                <div className="flex">
                    {!isConfirm ? (
                        <button
                            type="button"
                            onClick={onClickClose}
                            className="flex-1 bg-[#00489D] text-white leading-[28px] py-[12px] text-[18px] font-bold text-center"
                        >
                            확인
                        </button>
                    ) : (
                        <React.Fragment>
                            <button
                                type="button"
                                onClick={onClickClose}
                                className="flex-1 bg-[#E5E5F1] text-[#484964] leading-[28px] py-[12px] text-[18px] font-bold text-center"
                            >
                                취소
                            </button>
                            <Link
                                to="/"
                                className={`flex-1 bg-[#DC2626] text-white leading-[28px] py-[12px] text-[18px] font-bold text-center inline-block`}
                            >
                                확인
                            </Link>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};

export const ViewLargeImg = ({ src, closeOverlay }: { src: string; closeOverlay: () => void }) => {
    return (
        <div className="min-h-[100dvh] bg-white flex flex-col">
            <Header title="이미지 크게보기" goBack onClickGoBack={closeOverlay} />
            <figure className="flex-1 flex justify-center items-center">
                <img src={src} alt="" className="w-full" />
            </figure>
        </div>
    );
};
